import { Box, IconButton, useToast } from "@chakra-ui/react"
import Toast from "@components/Product/Toast"
import { useEffect, useState } from "react"
import { MdIosShare } from "react-icons/md"

const ProductShare = ({
  domain,
  name,
  alternateName,
  gtin,
}: {
  domain: string
  name: string
  alternateName: string
  gtin: string
}) => {
  const toast = useToast()

  const [canShare, setCanShare] = useState<boolean>(false)

  const handleShare = () => {
    if (navigator.share) {
      navigator
        .share({
          title: name,
          url: `${domain}/p/${alternateName}/${gtin}`,
        })
        .catch((error) => console.error("Error sharing", error))
    } else {
      toast({
        status: "info",
        render: ({ id, onClose }) => (
          <Toast
            id={id}
            status={"info"}
            title={"Sharing not supported"}
            description={"Please copy the link and share it manually"}
            isClosable
            onClose={onClose}
          />
        ),
      })
    }
  }

  useEffect(() => {
    if (typeof window !== "undefined" && typeof navigator !== "undefined") {
      setCanShare(navigator.share !== undefined)
    }
  }, [])

  return (
    <Box
      position={"relative"}
      flex={1}
    >
      {canShare && (
        <IconButton
          aria-label={"Share"}
          onClick={handleShare}
          icon={<MdIosShare />}
          variant={"ghost"}
          position={"absolute"}
          right={0}
          top={-2}
        />
      )}
    </Box>
  )
}

export default ProductShare
